﻿import type { ICellRendererParams } from 'ag-grid-community';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const cellTranslatorRenderer: () => FC<ICellRendererParams> =
  () =>
  ({ value }) => {
    if (value) {
      return <FormattedMessage id={`quote.products.${value}` as IntlKey} defaultMessage={value} />;
    }
    return <>{value}</>;
  };
